import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import { Note, PagedNote } from 'lib/Model/Note';

export function fetchNotes(
  companyId: string,
  pageNumber: number,
  itemsPerPage: number,
  withRelated: boolean,
  content?: string,
): Promise<PagedNote> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/companies/${companyId}/notes`, {
      params: {
        page: pageNumber,
        page_size: itemsPerPage,
        content,
        show_related: withRelated,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return {
        total_count: response.data.total_count,
        data: response.data.data as Note[],
      };
    });
}
